import { RegisteredComponent } from "@builder.io/sdk-react";

export const expandableFormBlockConfig: Omit<RegisteredComponent, "component"> =
  {
    name: "Expandable Form",
    description:
      "Wrapper for forms that hides extra fields until the user starts filling out the form. Form must use Form Field symbols for the hiding/showing to work correctly.",
    image:
      "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fef36d2a846134910b64b88e6d18c5ca5",
    canHaveChildren: true,
    noWrap: true,
    inputs: [
      {
        name: "maxVisibleFields",
        friendlyName: "Maximum Visible Fields",
        type: "number",
        required: false,
        localized: false,
        defaultValue: 3,
        helperText:
          "Number of form fields visible before expansion. Checkboxes and opt-ins don't count toward this limit.",
      },
    ],
  };
